import { render, staticRenderFns } from "./NutirtionDrawer.vue?vue&type=template&id=a57fb746&scoped=true"
import script from "./NutirtionDrawer.vue?vue&type=script&lang=js"
export * from "./NutirtionDrawer.vue?vue&type=script&lang=js"
import style0 from "./NutirtionDrawer.vue?vue&type=style&index=0&id=a57fb746&prod&lang=scss&scoped=true"
import style1 from "./NutirtionDrawer.vue?vue&type=style&index=1&id=a57fb746&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a57fb746",
  null
  
)

export default component.exports